import styled from "styled-components";

import { options } from "../styles";

export const PanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: ${({ borderRadius }) => `${borderRadius}px`};
  overflow: hidden;
`;

export const PanelHeader = styled.div`
  background-color: ${({ backgroundColor }) => backgroundColor};
  justify-content: ${({ justifyContent }) => justifyContent};
  display: flex;
  gap: 10px;
  padding: 16px;

  & > div {
    color: ${({ color }) => color};
  }
`;

export const PanelHeading = styled.h1`
  margin: 0;
  font-size: 16px;
  color: ${({ color }) => color};
  font-weight: 400;
  text-align: ${({ textAlign }) => textAlign};
`;

export const PanelContent = styled.div`
  padding: 16px;
  background-color: ${({ backgroundColor }) => `${backgroundColor}26`};
  color: ${({ color }) => color || "inherit"} !important;
  display: flex;
  flex-direction: column;
  text-align: ${({ justifyContent }) => justifyContent};
  justify-content: ${({ justifyContent }) =>
    options.justifyContent[justifyContent]};
`;

export const Emoji = styled.div`
  display: grid;
  place-content: center;
  width: 18px;
  height: 18px;
`;
